export const GA_TRACKING_ID = "UA-57253341-7";

// gtag added via _document

interface AnalyticsEvent {
  /**
   * action is the string that will appear as the event action in Google Analytics Event reports.
   */
  action: string;
  /**
   * category is the string that will appear as the event category.
   */
  category?: string;
  /**
   * label is the string that will appear as the event label.
   */
  label?: string;
  /**
   * value is a non-negative integer that will appear as the event value.
   */
  value?: number;
}

export function pageView(url: string) {
  if (window?.gtag)
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export function observeEvent(event: AnalyticsEvent) {
  const { action, category, label, value } = event;
  if (window?.gtag)
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
}
